import React,{ useEffect, useMemo, useState} from 'react'
import {MwButton, MwInputText,MwSpinnerButton, MwSelector} from '../ui'
import { useFetch } from '../../hooks'
import { useTranslation } from 'react-i18next';

const UpdatePaymentMethod = ({
    currentLangList,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    currentLangId,
    userId,
    data,
    putData,
    loading,
    currentItem
}) => {

    const [namepaymentMethod,setNamepaymentMethod] = useState({});
    const [despaymentMethod,setDescpaymentMethod] = useState({});
    const [treasurySelected, setTreasurySelected] = useState('');
    const [tabLang,setTabLang] = useState('en');
    const [t] = useTranslation('global');
    const financeBaseUrl = useMemo(() => {
      if (process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL) {
        return process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL.replace(/\/+$/, '');
      }
      if (process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL) {
        return process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL.replace(/\/sales\/?$/, '/finance').replace(/\/+$/, '');
      }
      return `${(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '')}/finance`;
    }, []);
    const { data: treasuriesResult } = useFetch(
      `${financeBaseUrl}/treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
    );
    const [treasuriesList, setTreasuriesList] = useState([]);

    const tabLangHandler = (newValue) => {
        setTabLang(newValue);
    }
    
    const submitHandler = (e) => {
        e.preventDefault();
        if( Object.keys(namepaymentMethod).length === 0 && Object.keys(despaymentMethod).length === 0 ) return
        let description = [];

        currentLangList.map((lang) => {
            if( !namepaymentMethod[lang.langCode] && !despaymentMethod[lang.langCode] ) return
            description = [...description, {
                "name": namepaymentMethod[lang.langCode],
                "desc" : despaymentMethod[lang.langCode],
                "lang" : lang.langCode
            }]
        })
        const _data = {
            "isActive" : true,
            "tenantId" : currentTenantId,
            "companyId": currentCompanyId,
            "branchId" : currentBranchId,
            "createdBy" : userId,
            "treasurie_id": treasurySelected?.value || '',
            "description" : description
        }
        console.log(_data);
        putData(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/update/${currentItem.id}`,_data)

    }

    useEffect(() => {
        if(!!data && !loading){
            setNamepaymentMethod({})
            setDescpaymentMethod({})
        }
    },[data]);

    useEffect(() => {
      if (!treasuriesResult?.data) return;
      const list = treasuriesResult.data.map((item) => ({
        label: currentLangId === 'ar' ? item.name_ar : item.name_en,
        value: item.id,
        lang: currentLangId,
      }));
      setTreasuriesList(list);
    }, [treasuriesResult, currentLangId]);

    useEffect(() => {
        const initialName = Object.keys(currentItem).length > 0 ? { en: currentItem?.description[0].name || ' ', ar:currentItem?.description[1]?.name || ''} : {} ;
        const initialDesc = Object.keys(currentItem).length > 0 ? { en: currentItem?.description[0].desc || '', ar:currentItem?.description[1]?.desc || ''}  : {} ;
        const treasuryValue = currentItem?.treasurie_id || currentItem?.treasury_id;
        
        setNamepaymentMethod(initialName);
        setDescpaymentMethod(initialDesc);
        if (treasuryValue) {
          const selectedFromList = treasuriesList.find((item) => String(item.value) === String(treasuryValue));
          setTreasurySelected(
            selectedFromList || {
              label: currentItem?.treasury_name || currentItem?.treasurie_name || '',
              value: treasuryValue,
              lang: currentLangId,
            }
          );
        } else {
          setTreasurySelected('');
        }
    },[currentItem, treasuriesList, currentLangId]);

    return (
        <div>
            <div className=' text-sm text-slate-500 pb-3'>{t("setting.paymentMethodList")}</div>
            <div className='p-3  rounded-lg border border-slate-200'>
                
                <form onSubmit={submitHandler}>
                    <div className='flex justify-between items-center'>
                        <div className=' text-xs py-2 text-[#251658]' >{t("setting.update_method")}</div>
                        { loading ? <MwSpinnerButton/> : <MwButton 
                            inGroup = {true}
                            size='sm'
                            type = 'saveBtn'  > Save
                            </MwButton> }
                    </div>
                    <div className='flex gap-2 mt-3 text-xs'>
                    { currentLangList.map( lang => ( <div key={lang._id} onClick={ () => tabLangHandler(lang.langCode)} className={` p-1 cursor-default ${tabLang === lang.langCode && 'bg-[#251658] p-1 rounded text-white ' }`} >{lang.langName}</div> )) }
                    </div>
                    <div className='flex flex-col gap-3 py-1  md:flex-row md:gap-0  '>
                        { currentLangList.map( lang => {
                            return  ( 
                                <div  key={lang._id} className={` flex flex-1 ${tabLang === lang.langCode ? 'block' : 'hidden'} `} >
                                    <MwInputText
                                        placeholder={t("setting.enter_method_name")}
                                        size='sm'
                                        value={namepaymentMethod[lang.langCode]}
                                        onChange={(e)=>setNamepaymentMethod({...namepaymentMethod, [lang.langCode]:e.target.value })}
                                    />
                                    <MwInputText
                                        placeholder={t("setting.enter_method_desc")}
                                        size='sm'
                                        value={despaymentMethod[lang.langCode]}
                                        onChange={(e)=>setDescpaymentMethod({...despaymentMethod, [lang.langCode]:e.target.value })}
                                    />
                                </div>
                            )})}
                    </div>
                    <div className='pt-2'>
                        <MwSelector
                            label={t('invoice.Treasury')}
                            initalValue={t('invoice.selectTreasury')}
                            dataType='labelValue'
                            _data={treasuriesList}
                            withAddNew={false}
                            withSearch={true}
                            selectedItem={treasurySelected}
                            setSelectedItem={setTreasurySelected}
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UpdatePaymentMethod
